import React, {Component} from 'react';
import Routes from './routes';

// import 'antd/dist/antd.css';


import 'react-table/react-table.css';

import './App.css';
import './assets/css/predefined.css'
import './assets/css/antd-overrides.css'
import './assets/css/customize.css'
import './assets/css/gs-theme.css'

/**
 * Root component of the application
 */
class App extends Component {
  render() {
    return (
      <div className="gs-theme">
        <Routes/>
      </div>
    );
  }
}

export default App;
